import { createContext, useContext, useState, type ReactNode } from 'react';

export type Design = 'A' | 'B' | 'C';

interface DesignState {
  design: Design;
  setDesign: (d: Design) => void;
}

const DesignContext = createContext<DesignState | null>(null);

export function DesignProvider({ children }: { children: ReactNode }) {
  const [design, setDesignState] = useState<Design>(() => {
    const stored = localStorage.getItem('crewpool-design');
    return (stored === 'A' || stored === 'B' || stored === 'C') ? stored : 'A';
  });

  const setDesign = (d: Design) => {
    localStorage.setItem('crewpool-design', d);
    setDesignState(d);
  };

  return (
    <DesignContext.Provider value={{ design, setDesign }}>
      {children}
    </DesignContext.Provider>
  );
}

export function useDesign() {
  const ctx = useContext(DesignContext);
  if (!ctx) throw new Error('useDesign must be used within DesignProvider');
  return ctx;
}
